import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {DataTablesResponse} from "../models/dataTables-response";
import {webServiceConfig} from "../config/web-service.config";
import {map} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class SubTypeProductService {

    constructor(private http: HttpClient) { }

    getDatatable(dataTablesParameters): Observable<any> {
        return this.http.post<DataTablesResponse>(`${webServiceConfig.webServiceUrl}sub-type-products/datatable`, dataTablesParameters, {})
            .pipe(map(response => {
                return response;
            }));
    }

    getById(subTypeProductId: number): Observable<any> {
        return this.http.get(`${webServiceConfig.webServiceUrl}sub-type-products/${subTypeProductId}`).pipe(map(response => {
            return response;
        }));
    }

    store(subTypeProduct: any): Observable<any> {
        return this.http.post(`${webServiceConfig.webServiceUrl}sub-type-products`, subTypeProduct)
            .pipe(map(response => {
                return response;
            }));
    }

    update(subTypeProduct: any): Observable<any> {
        return this.http.put(`${webServiceConfig.webServiceUrl}sub-type-products/${subTypeProduct.id}`, subTypeProduct)
            .pipe(map(response => {
                return response;
            }));
    }

    delete(id: number): Observable<any> {
        return this.http.delete(`${webServiceConfig.webServiceUrl}sub-type-products/${id}`)
            .pipe(map(response => {
                return response;
            }));
    }
}
